import type { FilterConfigBarItemDefault } from '@rocco/ui/filter-sort/types/filter-config-bar';
import type { MultipleValuesFilterState } from '@rocco/ui/filter-sort/view-models/filter-state/multiple-values-filter-state';
import type { FilterBarElementProps } from '@rocco/ui/filter-sort/components/filters-bar/FiltersBarElement';
import { useFiltersContext } from '@rocco/ui/filter-sort/components/Filters';
import { Checkbox as RoccoCheckbox } from '@rocco/components/checkbox';
import { Label as RoccoLabel } from '@rocco/components/label';

export const FiltersBarMultipleValues = (
    props: FilterBarElementProps<
        FilterConfigBarItemDefault,
        MultipleValuesFilterState
    >,
) => {
    const { filterState, onFilterStateUpdate } = props;
    const {
        searchFilters: { handleToggleMultipleValues },
    } = useFiltersContext();

    return (
        <div className="flex flex-col gap-2">
            {filterState.items.map((item, index) => (
                <div
                    key={index}
                    className="flex items-center h-8 border-transparent border px-2 rounded-2
                    hover:bg-primary-foreground hover:text-primary hover:border-black group cursor-pointer"
                >
                    <RoccoCheckbox
                        id={item.value}
                        checked={item.checked}
                        groupHover="light"
                        onCheckedChange={checked => {
                            handleToggleMultipleValues &&
                                onFilterStateUpdate(
                                    handleToggleMultipleValues(
                                        filterState,
                                        item,
                                        !!checked,
                                    ),
                                    true,
                                );
                        }}
                    />

                    <RoccoLabel htmlFor={item.value} target="checkbox">
                        {item.label}
                    </RoccoLabel>
                </div>
            ))}
        </div>
    );
};
